export const EMAIL_REGEX = /^[a-zA-Z0-9!#$%&'+^_`{}~-]+(?:\.[a-zA-Z0-9!#$%&'+^_`{}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
export const TABLE_SCROLL_DIFFERENCE = 215;
export const PAGE_SIZE_VALUES = [10, 20, 30, 50];
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_VALUES[0];
export const DEFAULT_TEXT_INPUT_MIN_LENGTH = 3;
export const DEFAULT_TEXT_INPUT_MAX_LENGTH = 100;
export const EMAIL_MAX_LENGTH = 70;
export const COUNTER_INPUT_MIN_VALUE = 1;
export const COUNTER_INPUT_MAX_VALUE = 9999;
export const PHONE_NUMBER_MIN_LENGTH = 10;
export const PHONE_NUMBER_MAX_LENGTH = 20;
export const NUMBER_REGEX = /^\d*$/;
export const DECIMAL_REGEX = /^-?(\d{1,13}\.?\d{0,2}$|\d{1,15}$)|^-?$/;
export const POSITIVE_DECIMAL_REGEX = /^(\d{1,13}\.?\d{0,2}$|\d{1,15}$)|^-?$/;
export const TEXT_REGEX = /^([^\s]+[ ]?)*$/;
export const FISCAL_IDENTIFIER_MIN_LENGTH = 2;
export const FISCAL_IDENTIFIER_MAX_LENGTH = 20;
export const COMPANY_ACTIVITY_CODE_LENGTH = 4;
export const FISCAL_YEAR_MIN_YEAR = 2019;
export const COMMENT_MIN_LENGTH = 20;
export const TABLE_SELECTOR = 'div.ant-table';
export const TABLE_ROW_SELECTOR = 'tr.ant-table-row';
export const LAYOUT_SELECTOR = 'main.ant-layout-content';
export const MAX_ACCEPTED_DIGITS = 15;
export const MIN_DECIMAL_PLACES = 2;
export const MAX_DECIMAL_PLACES = 4;
export const ACCEPTED_DOCUMENTS = '.doc,.docx,.odt,.pdf,.rtf,.txt,.xml,.xps,.csv,.ods,.xls,.xlsx,.xlsb,.xlw,.bmp,.gif,.jpg,.jpeg,.odp,.png,.ppt,.pptx,.pps,.ppsx,.tif,.tiff,.mp4,.avi,.mpeg,.mpg,.msg';
export const MAX_ROWS_IN_DOCUMENTS_TABLE = 7;
export const MAX_ROWS_IN_STEP_DOCUMENTS_TABLE = 5;
export const INVALID_CHARACTERS_IN_DOCUMENTS_NAMES_REGEX = /[\\/:"*?<>|]+/;
export const IDLE_TIMEOUT = (1000 * 60) * 25;
export const BALANCE_TEMPLATE_FILE_NAME = 'CalculationBalanceTemplate.xls';
